// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34YwD","largestCol":"styles_largestCol__1NkIB","smallestCol":"styles_smallestCol__2oJQa"};